import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { HtmlViewWrapper } from "./HtmlView.style";
import { NotFound } from "components";
import { CircularProgress, Grid, useMediaQuery, useTheme } from "@mui/material";
import { useStoreContext } from "context/storeContext";

type IHtmlViewProps = {};

export const HtmlView: FC<IHtmlViewProps> = () => {
  const theme = useTheme();
  const { filename } = useParams();
  const [fileContent, setFileContent] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    actions: { setHeight },
    states: { height },
  } = useStoreContext();

  useEffect(() => {
    const loadFile = async () => {
      try {
        setIsLoading(true);
        const filePath = await import(`../../files/${filename}`);
        setFileContent(filePath.default);
        setIsLoading(false);
      } catch (error) {
        setFileContent("");
        setIsLoading(false);
      }
    };
    loadFile();
  }, [filename]);

  return (
    <HtmlViewWrapper
      className="html-container"
      sx={{ height: `${!fileContent && isMobile ? 450 : height}px` }}
    >
      {isLoading ? (
        <Grid className="loader">
          <CircularProgress />
        </Grid>
      ) : fileContent ? (
        <iframe
          scrolling="no"
          onLoad={(e) => {
            const iframe = e.target;
            const iframeDocument =
              (iframe as any).contentDocument ||
              (iframe as any).contentWindow.document;
            const iframeContentHeight = iframeDocument.body.scrollHeight + 20;
            setHeight(
              iframeContentHeight < 850
                ? isMobile
                  ? iframeContentHeight < 450
                    ? 450
                    : iframeContentHeight
                  : 850
                : iframeContentHeight,
            );
          }}
          src={fileContent}
          className="iframe"
          title="html-file"
          height={`${!fileContent && isMobile ? 450 : height}px`}
        />
      ) : (
        fileContent === "" && <NotFound />
      )}
    </HtmlViewWrapper>
  );
};
